import type { Requester } from '@labeling/globals';

export const ROLE_ORDER: Requester['type'][] = ['admin', 'maintainer', 'user', 'operator'];

export const roleLabel = (type: Requester['type'], t: (key: string) => string): string => {
  switch (type) {
    case 'admin':
      return t('navbar.display.roleAdmin');
    case 'maintainer':
      return t('navbar.display.roleMaintainer');
    case 'user':
      return t('navbar.display.roleUser');
    case 'operator':
      return t('navbar.display.roleOperator');
  }
};
